export const checkoutInitialValues = {
    name: '',
    cellphone: '',
    address: '',
    location: ''
}

export const registerInitialValue = {
    name: "",
    email: "",
    password: "",
}


export const loginInitialValues = {
    email: "",
    password: "",
}